import { render } from "./BubbleMenu.vue?vue&type=template&id=a22c13fa&scoped=true"
import script from "./BubbleMenu.vue?vue&type=script&lang=js"
export * from "./BubbleMenu.vue?vue&type=script&lang=js"

import "./BubbleMenu.vue?vue&type=style&index=0&id=a22c13fa&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a22c13fa"]])

export default __exports__